import store from "../store";

let userTypeMiddleware = type => {
  let currentUserType = store.getters.getUserType;
  return currentUserType && currentUserType === type;
};

const routes = [
  {
    path: "/",
    alias: "/zapis",
    name: "appointments",
    component: () =>
      import(/* webpackChunkName: "appointments" */ "../views/Appointments.vue"),
    props: (route) => ({
      isArchive: false,
    }),
  },
  {
    path: "/archive",
    name: "appointments-archive",
    component: () =>
      import(/* webpackChunkName: "appointments" */ "../views/Appointments.vue"),
    props: (route) => ({
      isArchive: true,
    }),
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    meta: {
      isPublic: true
    }
  },
  {
    path: "/profile",
    name: "Profile",
    component: () =>
      import(/* webpackChunkName: "profile" */ "../views/Profile.vue")
    // beforeEnter: (to, from, next) => {
    //   return userTypeMiddleware("client") ? next() : next("/");
    // }
  },
  {
    path: "/appointments/:id",
    alias: "/zapis/appointments/:id",
    name: "AppointmentItem",
    component: () =>
      import(
        /* webpackChunkName: "appointment-item" */ "../views/AppointmentItem.vue"
      )
  },
  {
    path: "/appointment-request",
    alias: "/zapis/appointment-request",
    name: "AppointmentAccept",
    component: () =>
      import(
        /* webpackChunkName: "appointment-accept" */ "../views/AppointmentAccept.vue"
      ),
    meta: {
      isPublic: true
    }
  },
  {
    path: "/timetable",
    name: "Timetable",
    component: () =>
      import(/* webpackChunkName: "timetable" */ "../views/Timetable.vue"),
    beforeEnter: (to, from, next) => {
      return userTypeMiddleware("notary") ? next() : next("/");
    }
  },
  {
    path: "/messages",
    name: "Messages",
    component: () =>
      import(/* webpackChunkName: "messages" */ "../views/Messages.vue")
  },
  {
    path: "/password-reset",
    alias: "/zapis/password-reset",
    name: "ResetPassword",
    component: () =>
      import(
        /* webpackChunkName: "reset-password" */ "../views/ResetPassword.vue"
      ),
    meta: {
      isPublic: true
    }
  }
];

export default routes;
